import { BaseModelActive } from '../../../shared/base/base.models';
import { Company } from '../companies/companies.models';

export class ThirdPartyApiAuthentication extends BaseModelActive {
    api?: ThirdPartyApi;
    username?: string;
    password?: string;
    apiKey?: string;
    company?: Company;
}

export enum ThirdPartyApi {
    OPA, GOOGLE_ANALYTICS
}